// config.js or apiKeys.js
const apiKeys = {
  key: process.env.REACT_APP_WEATHER_API_KEY,
  base: process.env.REACT_APP_API_BASE_URL,
};

export default apiKeys;
